class GradaHero extends HTMLElement {
  constructor() {
    super();
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.dots = [...this.querySelectorAll('[data-dot]')];
    this.current = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
    this.timer = null;
    this.mobileViewport = window.matchMedia('(max-width: 749px)');
  }

  connectedCallback() {
    if (this.slides.length < 2) return;
    this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.current - 1, true));
    this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.current + 1, true));
    this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot), true)));
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
    this.mobileViewport.addEventListener('change', this.onViewportChange);
    document.addEventListener('shopify:block:select', this.onBlockSelect);
    this.start();
  }

  disconnectedCallback() {
    this.stop();
    this.mobileViewport.removeEventListener('change', this.onViewportChange);
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  onViewportChange = () => {
    if (this.mobileViewport.matches) this.stop();
    else this.start();
  };

  onBlockSelect = (event) => {
    const selected = this.slides.findIndex((slide) => slide.contains(event.target) || slide === event.target);
    if (selected >= 0) this.show(selected, true);
  };

  show(index, userInitiated = false) {
    const next = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, position) => {
      const active = position === next;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
    });
    this.dots.forEach((dot, position) => {
      const active = position === next;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', String(active));
    });
    this.current = next;
    const status = this.querySelector('[data-status]');
    if (status && userInitiated) status.textContent = `Diapositiva ${next + 1} de ${this.slides.length}`;
    if (userInitiated) {
      this.stop();
      this.start();
    }
  }

  start() {
    this.stop();
    if (
      this.dataset.autoplay !== 'true' ||
      this.mobileViewport.matches ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) return;
    this.timer = window.setInterval(() => this.show(this.current + 1), Number(this.dataset.speed) || 6000);
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
  }
}

if (!customElements.get('grada-hero')) customElements.define('grada-hero', GradaHero);
